import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tabNav" }
const _hoisted_2 = {
  key: 0,
  class: "modalcontent"
}
const _hoisted_3 = {
  key: 1,
  class: "modalcontent"
}
const _hoisted_4 = {
  key: 2,
  class: "modalcontent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HistoriqueEquipement = _resolveComponent("HistoriqueEquipement")!
  const _component_CaracteristiquesEquipement = _resolveComponent("CaracteristiquesEquipement")!
  const _component_GammeMaintenance = _resolveComponent("GammeMaintenance")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onCancel: _ctx.modalEquipementCancel }, {
    default: _withCtx(() => [
      _createVNode(_component_ModalCard, {
        onCancel: _ctx.modalEquipementCancel,
        noPaddingTop: true,
        withoutBotNav: true,
        headerTitle: _ctx.$t('preventif.suivi.modal.equipment.title'),
        "active-validate": false,
        class: "page"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.switchTabActivated(0))),
              class: _normalizeClass(_ctx.tabActivated === 0 && 'active')
            }, _toDisplayString(_ctx.$t('preventif.suivi.modal.equipment.nav.history')), 3),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (this.switchTabActivated(1))),
              class: _normalizeClass(_ctx.tabActivated === 1 && 'active')
            }, _toDisplayString(_ctx.$t('preventif.suivi.modal.equipment.nav.caracteristics')), 3),
            (!_ctx.preventif)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (this.switchTabActivated(2))),
                  class: _normalizeClass(_ctx.tabActivated === 2 && 'active')
                }, _toDisplayString(_ctx.$t('preventif.suivi.modal.equipment.nav.gamme.maintenance')), 3))
              : _createCommentVNode("", true)
          ]),
          (this.tabActivated === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_HistoriqueEquipement, {
                  preventif: _ctx.preventif,
                  "phase-id": _ctx.phaseId
                }, null, 8, ["preventif", "phase-id"])
              ]))
            : _createCommentVNode("", true),
          (this.tabActivated === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_CaracteristiquesEquipement)
              ]))
            : _createCommentVNode("", true),
          (this.tabActivated === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_GammeMaintenance)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onCancel", "headerTitle"])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}